import {useSyncExternalStore} from 'react';

let readOnly = false;
const listeners = new Set();

export const READ_ONLY_BODY_CLASS = 'jm-readonly-editor';
export const READ_ONLY_BLOCK_CLASS = 'jm-readonly-block';

const READ_ONLY_HIDE_SELECTORS = [
    '.blocklyToolbox',
    '.blocklyToolboxDiv',
    '.blocklyFlyout',
    '.blocklyFlyoutScrollbar'
];

let styleInjected = false;
export const ensureReadOnlyStyle = () => {
    if (styleInjected || typeof document === 'undefined') return;
    styleInjected = true;
    const hide = READ_ONLY_HIDE_SELECTORS
        .map(sel => `body.${READ_ONLY_BODY_CLASS} ${sel}`)
        .join(',');
    const style = document.createElement('style');
    style.textContent =
        `${hide}{display:none !important;}` +
        `.${READ_ONLY_BLOCK_CLASS}{cursor:not-allowed;}` +
        `.${READ_ONLY_BLOCK_CLASS} *{pointer-events:none;}`;
    document.head.appendChild(style);
};

export const setReadOnly = value => {
    if (readOnly === value) return;
    readOnly = value;
    listeners.forEach(listener => listener());
};

const subscribe = listener => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

export const useReadOnly = () => useSyncExternalStore(subscribe, () => readOnly);

export const getReadOnly = () => readOnly;
